import React, { useState, useEffect } from "react";
import { Timeline } from "react-twitter-widgets";
import Select from "react-select";
import ToggleButton from "@material-ui/lab/ToggleButton";
import ToggleButtonGroup from "@material-ui/lab/ToggleButtonGroup";
// import { TwitterTimelineEmbed, TwitterShareButton, TwitterFollowButton, TwitterHashtagButton, TwitterMentionButton, TwitterTweetEmbed, TwitterMomentShare, TwitterDMButton, TwitterVideoEmbed, TwitterOnAirButton } from 'react-twitter-embed';
// import TweetEmbed from 'react-tweet-embed'
// import Twemb from "./Twemb";
// import { SoccerWordContext } from "./context/SoccerWordContext";
const LeagueContinents = {
  Europe_m: [
    { value: "LaLiga", label: "ラ・リーガ" },
    { value: "SerieA", label: "セリエＡ" },
    { value: "bundesliga_de", label: "ブンデス" },
    { value: "premierleague", label: "プレミア" },
    { value: "League1", label: "リーグ・アン" },
    { value: "JupilerLeague", label: "ジュピラーリーグ" },
    { value: "Eredivisie", label: "エールディヴィジ" },
    { value: "PrimeiraLiga", label: "プリメイラ・リーガ" },
    { value: "japaneseplayer", label: "日本人所属" },
  ],
  SAmerica_m: [
    { value: "BrasileiroSerieA", label: "ブラジレイロ・セリエA" },
  ],
  NAmerica_m: [
    { value: "LigaMX", label: "リーガMX" },
    { value: "MSLE", label: "MLS東" },
    { value: "MSLW", label: "MLS西" },
    { value: "NWSL", label: "アメリカ女子" },
  ],
  Asia_m: [
    { value: "J1", label: "J1" },
    { value: "J2", label: "J2" },
    { value: "J3", label: "J3" },
    { value: "WE", label: "WE" },
    { value: "Nadeshiko1", label: "なでしこ1部" },
    { value: "Nadeshiko2", label: "なでしこ2部" },
    
  ]
}
const LeagueOptions = {
  LaLiga: [
    { value: "realmadrid", label: "レアル・マドリード" },
    { value: "FCBarcelona_es", label: "バルセロナ" },
    { value: "Atleti", label: "アトレティコ・マドリード" },
    { value: "SevillaFC", label: "セビージャ" },
    { value: "RealBetis", label: "ベティス" },
    { value: "RealSociedad", label: "レアル・ソシエダ" },
    { value: "VillarrealCF", label: "ビジャレアル" },
    { value: "athleticclub", label: "アスレティック・ビルバオ" },
    { value: "valenciacf", label: "バレンシア" },
    { value: "CAOsasuna", label: "オサスナ" },
    { value: "RCCelta", label: "セルタ・ビーゴ" },
    { value: "RayoVallecano", label: "ラージョ・バジェカーノ" },
    { value: "elchecf", label: "エルチェ" },
    { value: "rcdespanyol", label: "エスパニョール" },
    { value: "GetafeCF", label: "ヘタフェ" },
    { value: "RCD_Mallorca", label: "マヨルカ" },
    { value: "GranadaCF", label: "グラナダ" },
    { value: "Cadiz_CF", label: "カディス" },
    { value: "U_D_Almeria", label: "UDアルメリア" },
    { value: "realvalladolid", label: "バリャドリード" },
    { value: "gironafc", label: "ジローナ" },
    { value: "LaLiga", label: "ラ・リーガ" },
  ],
  SerieA: [
    { value: "acmilan", label: "ミラン" },
    { value: "Inter", label: "インテル" },
    { value: "SSCNapoli", label: "ナポリ" },
    { value: "juventusfc", label: "ユヴェントス" },
    { value: "OfficialSSLazio", label: "ラツィオ" },
    { value: "OfficialASRoma", label: "ローマ" },
    { value: "acffiorentina", label: "フィオレンティーナ" },
    { value: "Atalanta_BC", label: "アタランタ" },
    { value: "HellasVeronaFC", label: "ヴェローナ" },
    { value: "TorinoFC_1906", label: "トリノ" },
    { value: "SassuoloUS", label: "サッスオーロ" },
    { value: "Udinese_1896", label: "ウディネーゼ" },
    { value: "BfcOfficialPage", label: "ボローニャ" },
    { value: "EmpoliCalcio", label: "エンポリ" },
    { value: "sampdoria", label: "サンプドリア" },
    { value: "acspezia", label: "スペツィア" },
    { value: "OfficialUSS1919", label: "サレルニターナ" },
    { value: "OfficialUSLecce", label: "レッチェ" },
    { value: "USCremonese", label: "クレモネーゼ" },
    { value: "ACMonza", label: "モンツァ" },
    { value: "SerieA", label: "セリエＡ" },
  ],
  bundesliga_de: [
    { value: "FCBayern", label: "バイエルン・ミュンヘン" },
    { value: "BVB", label: "ドルトムント" },
    { value: "bayer04fussball", label: "レバークーゼン" },
    { value: "RBLeipzig", label: "ライプツィヒ" },
    { value: "fcunion", label: "ウニオン・ベルリン" },
    { value: "scfreiburg", label: "フライブルク" },
    { value: "fckoeln", label: "ケルン" },
    { value: "1fsvmainz05", label: "マインツ" },
    { value: "tsghoffenheim", label: "ホッフェンハイム" },
    { value: "borussia", label: "ボルシアMG" },
    { value: "Eintracht", label: "フランクフルト" },
    { value: "VfL_Wolfsburg", label: "ヴォルフスブルク" },
    { value: "VfLBochum1848eV", label: "ボーフム" },
    { value: "FCAugsburg", label: "アウクスブルク" },
    { value: "vfb", label: "シュトゥットガルト" },
    { value: "HerthaBSC", label: "ヘルタ・ベルリン" },
    { value: "s04", label: "シャルケ" },
    { value: "werderbremen", label: "ブレーメン" },
    { value: "bundesliga_de", label: "ブンデス" },
  ],
  premierleague: [
    { value: "ManCity", label: "マンチェスター・シティ" },
    { value: "LFC", label: "リヴァプール" },
    { value: "ChelseaFC", label: "チェルシー" },
    { value: "SpursOfficial", label: "トッテナム・ホットスパー" },
    { value: "Arsenal", label: "アーセナル" },
    { value: "ManUtd", label: "マンチェスター・ユナイテッド" },
    { value: "WestHam", label: "ウェストハム・ユナイテッド" },
    { value: "LCFC", label: "レスター・シティ" },
    { value: "OfficialBHAFC", label: "ブライトン&ホーヴ・アルビオン" },
    { value: "Wolves", label: "ウルヴァーハンプトン・ワンダラーズ" },
    { value: "NUFC", label: "ニューカッスル・ユナイテッド" },
    { value: "CPFC", label: "クリスタル・パレス" },
    { value: "brentfordfc", label: "ブレントフォード" },
    { value: "AVFCOfficial", label: "アストン・ヴィラ" },
    { value: "SouthamptonFC", label: "サウサンプトン" },
    { value: "Everton", label: "エヴァートン" },
    { value: "LUFC", label: "リーズ・ユナイテッド" },
    { value: "FulhamFC", label: "フラム" },
    { value: "afcbournemouth", label: "ボーンマス" },
    { value: "NFFC", label: "ノッティンガム・フォレスト" },
    { value: "premierleague", label: "プレミア" },
  ],
  League1: [
    { value: "PSG_inside", label: "パリ・サンジェルマン" },
    { value: "OM_Officiel", label: "マルセイユ" },
    { value: "as_monaco", label: "モナコ" },
    { value: "staderennais", label: "レンヌ" },
    { value: "ogcnice", label: "ニース" },
    { value: "RCSA", label: "ストラスブール" },
    { value: "rclens", label: "RCランス" },
    { value: "ol", label: "リヨン" },
    { value: "FCNantes", label: "ナント" },
    { value: "losclive", label: "リール" },
    { value: "SB29", label: "ブレスト" },
    { value: "StadedeReims", label: "スタッド・ランス" },
    { value: "MontpellierHSC", label: "モンペリエ" },
    { value: "angerssco", label: "アンジェ" },
    { value: "estac_officiel", label: "トロワ" },
    { value: "FCLorient", label: "ロリアン" },
    { value: "clermontfoot", label: "クレルモン" },
    { value: "ToulouseFC", label: "トゥールーズ" },
    { value: "ACAjaccio", label: "アジャクシオ" },
    { value: "AJA", label: "オセール" },
    { value: "Ligue1UberEats", label: "リーグ・アン" },
  ],
  JupilerLeague: [
    { value: "ClubBrugge", label: "クラブ・ブルッヘ" },
    { value: "UnionStGilloise", label: "サン＝ジロワーズ" },
    { value: "rscanderlecht", label: "アンデルレヒト" },
    { value: "official_rafc", label: "アントワープ" },
    { value: "KAAGent", label: "ヘント" },
    { value: "KRCGenkofficial", label: "ヘンク" },
    { value: "SportCharleroi", label: "シャルルロワ" },
    { value: "kvmechelen", label: "メヘレン" },
    { value: "stvv", label: "シント＝トロイデン" },
    { value: "cercleofficial", label: "サークル・ブルッヘ" },
    { value: "OHLeuven", label: "ルーヴェン" },
    { value: "kvoostende", label: "オーステンデ" },
    { value: "kvkofficieel", label: "コルトレイク" },
    { value: "Standard_RSCL", label: "スタンダール・リエージュ" },
    { value: "kas_eupen", label: "オイペン" },
    { value: "ESSEVEELIVE", label: "ズルテ・ワレヘム" },
    { value: "RfcSeraing167", label: "スラン" },
    { value: "KVCWesterlo", label: "ウェステルロー" },
    { value: "ProLeagueBE", label: "ジュピラーリーグ" },
  ],
  Eredivisie: [
    { value: "AFCAjax", label: "アヤックス" },
    { value: "psv", label: "PSV" },
    { value: "Feyenoord", label: "フェイエノールト" },
    { value: "fctwente", label: "トゥウェンテ" },
    { value: "AZAlkmaar", label: "AZアルクマール" },
    { value: "MijnVitesse", label: "フィテッセ" },
    { value: "fcutrecht", label: "ユトレヒト" },
    { value: "scHeerenveen", label: "ヘーレンフェーン" },
    { value: "SCCambuurLwd", label: "カンブール" },
    { value: "RKCWAALWIJK", label: "ヴァールヴァイク" },
    { value: "necnijmegen", label: "NECナイメヘン" },
    { value: "fcgroningen", label: "フローニンゲン" },
    { value: "GAEagles", label: "ゴー・アヘッド・イーグルス" },
    { value: "SpartaRotterdam", label: "スパルタ" },
    { value: "FortunaSittard", label: "フォルトゥナ・シッタート" },
    { value: "FC_Emmen", label: "エメン" },
    { value: "fcvolendam", label: "フォレンダム" },
    { value: "excelsiorrdam", label: "エクセルシオール" },
  ],
  PrimeiraLiga: [
    { value: "FCPorto", label: "FCポルト" },
    { value: "Sporting_CP", label: "スポルティング" },
    { value: "SLBenfica", label: "ベンフィカ" },
    { value: "SCBragaOficial", label: "ブラガ" },
    { value: "GilVicente_fc", label: "ジル・ヴィセンテ" },
    { value: "VitoriaSC1922", label: "ヴィトーリア" },
    { value: "CD_SantaClara", label: "サンタ・クララ" },
    { value: "FCF1931_Oficial", label: "ファマリカン" },
    { value: "estorilpraiasad", label: "エストリル・プライア" },
    { value: "MaritimoMadeira", label: "マリティモ" },
    { value: "fcpf", label: "パソス・デ・フェレイラ" },
    { value: "boavistaoficial", label: "ボアヴィスタ" },
    { value: "PortimonenseSAD", label: "ポルティモネンセ" },
    { value: "FCVizelaOficial", label: "FCヴィゼラ" },
    { value: "RioAve_FC", label: "リオ・アヴェ" },
    { value: "casapiaac", label: "カーザ・ピア" },
    // { value: "MoreirenseFC", label: "モレイレンセ" },
  ],
  japaneseplayer: [
    // { value: "SouthamptonFC", label: "サウサンプトン" },
    // { value: "LFC", label: "リヴァプール" },
    { value: "Arsenal", label: "アーセナル" },
    { value: "OfficialBHAFC", label: "ブライトン&ホーヴ・アルビオン" },
    { value: "htafc", label: "ハダースフィールド" },
    // { value: "NUFC", label: "ニューカッスル・ユナイテッド" },
    // { value: "realmadrid", label: "レアル・マドリード" },
    // { value: "RCD_Mallorca", label: "マヨルカ" },
    // { value: "GetafeCF", label: "ヘタフェ" },
    // { value: "SDEibar", label: "エイバル" },
    { value: "RealSociedad", label: "レアル・ソシエダ" },
    { value: "alaves", label: "アラベス" },
    { value: "SDHuesca", label: "ウエスカ" },
    { value: "CDLeganes", label: "レガネス" },
    // { value: "FCCartagena_efs", label: "カルタヘナ" },
    // { value: "BfcOfficialPage", label: "ボローニャ" },
    // { value: "sampdoria", label: "サンプドリア" },
    { value: "Eintracht", label: "フランクフルト" },
    { value: "fcunion", label: "ウニオン・ベルリン" },
    { value: "scfreiburg", label: "フライブルク" },
    { value: "borussia", label: "ボルシアMG" },
    { value: "VfLBochum1848eV", label: "ボーフム" },
    { value: "vfb", label: "シュトゥットガルト" },
    { value: "s04", label: "シャルケ" },
    { value: "arminia", label: "ビーレフェルト" },
    // { value: "werderbremen", label: "ブレーメン" },
    // { value: "s04", label: "シャルケ" },
    { value: "f95", label: "デュッセルドルフ" },
    { value: "Hannover96", label: "ハノーファー" },
    { value: "1_FCM", label: "マクデブルク" },
    { value: "EintrachtBSNews", label: "ブラウンシュヴァイク" },
    // { value: "fcstpauli", label: "ザンクトパウリ" },
    // { value: "OM_Officiel", label: "マルセイユ" },
    { value: "as_monaco", label: "モナコ" },
    { value: "RCSA", label: "ストラスブール" },
    { value: "StadedeReims", label: "スタッド・ランス" },
    { value: "ToulouseFC", label: "トゥールーズ" },
    { value: "nimesolympique", label: "ニーム" },
    // { value: "FCPorto", label: "FCポルト" },
    // { value: "RioAve_FC", label: "リオ・アヴェFC" },
    { value: "Sporting_CP", label: "スポルティング" },
    { value: "GilVicente_fc", label: "ジル・ヴィセンテ" },
    { value: "VitoriaSC1922", label: "ヴィトーリア" },
    { value: "CD_SantaClara", label: "サンタ・クララ" },
    // { value: "PortimonenseSC", label: "ポルティモネンセ" },
    { value: "boavistaoficial", label: "ボアヴィスタ" },
    { value: "PortimonenseSAD", label: "ポルティモネンセ" },
    // { value: "estorilpraiasad", label: "エストリル・プライア" },
    { value: "UnionStGilloise", label: "サン＝ジロワーズ" },
    // { value: "KRCGenkofficial", label: "ヘンク" },
    { value: "official_rafc", label: "アントワープ" },
    { value: "SportCharleroi", label: "シャルルロワ" },
    { value: "kvoostende", label: "オーステンデ" },
    // { value: "cercleofficial", label: "サークル・ブルッヘ" },
    // { value: "kbeerschotva", label: "ベールスホット" },
    { value: "stvv", label: "シント＝トロイデン" },
    { value: "cercleofficial", label: "サークル・ブルッヘ" },
    { value: "kvkofficieel", label: "コルトレイク" },
    { value: "ClubNxt", label: "Club NXT（本間至恩）" },
    // { value: "LommelSKOff", label: "ロンメルSK" },
    { value: "AZAlkmaar", label: "AZアルクマール" },
    { value: "fcutrecht", label: "ユトレヒト" },
    // { value: "psv", label: "PSV" },
    { value: "SCCambuurLwd", label: "カンブール" },
    { value: "SpartaRotterdam", label: "スパルタ" },
    // { value: "fcgroningen", label: "フローニンゲン" },
    // { value: "PECZwolle", label: "ズヴォレ" },
    { value: "CelticFC", label: "セルティック" },
    { value: "JamTarts", label: "ハーツ" },
    // { value: "RedBullSalzburg", label: "ザルツブルク" },
    // { value: "skrapid", label: "ラピード・ウィーン" },
    { value: "LASK_Official", label: "LASKリンツ" },
    { value: "SKNStPoelten", label: "SKNザンクト・ペルテン（二田理央）" },
    // { value: "FCSion", label: "FCシオン" },
    { value: "gc_zuerich", label: "グラスホッパー" },
    { value: "lausanne_sport", label: "ローザンヌ" },
    // { value: "rostovfc", label: "ロストフ" },
    // { value: "fcrk", label: "ルビン・カザン" },
    // { value: "FKPartizanBG", label: "パルチザン・ベオグラード" },
  ],
  BrasileiroSerieA: [
    { value: "flamengo", label: "フラメンゴ" },
    { value: "SCInternacional", label: "インテルナシオナル" },
    { value: "atletico", label: "アトレチコ・ミネイロ" },
    { value: "SaoPauloFC", label: "サンパウロ" },
    { value: "fluminensefc", label: "フルミネンセ" },
    { value: "gremio", label: "グレミオ" },
    { value: "Palmeiras", label: "パルメイラス" },
    { value: "SantosFC", label: "サントス" },
    { value: "AthleticoPR", label: "アトレチコ・パラナエンセ" },
    { value: "RedBullBraga", label: "レッドブル・ブラガンチーノ" },
    { value: "CearaSC", label: "セアラー" },
    { value: "corinthians", label: "コリンチャンス" },
    { value: "ACGOficial", label: "アトレチコ・ゴイアニエンセ" },
    { value: "ecbahia", label: "バイーア" },
    { value: "sportrecife", label: "スポルチ・レシフェ" },
    { value: "FortalezaEC", label: "フォルタレーザ" },
    { value: "nauticope", label: "ナウチコ" },
    { value: "Coritiba", label: "コリチーバ" },
    { value: "oficialguarani", label: "グアラニ" },
    { value: "CRBoficial", label: "CRB" },
  ],
  LigaMX : [
    { value: "ClubAmerica", label: "クラブ・アメリカ" },
    { value: "AtlasFC", label: "アトラス" },
    { value: "AtletideSanLuis", label: "アトレティコ・サン・ルイス" },
    { value: "CruzAzul", label: "クルス・アスル" },
    { value: "chivas", label: "チーバス・グアダラハラ" },
    { value: "fcjuarezoficial", label: "フアレス" },
    { value: "clubleonfc", label: "クラブ・レオン" },
    { value: "MazatlanFC", label: "マサトラン" },
    { value: "rayados", label: "モンテレイ" },
    { value: "clubnecaxa", label: "クルブ・ネカクサ" },
    { value: "Tuzos", label: "パチューカ" },
    { value: "ClubPueblaMX", label: "プエブラ" },
    { value: "Club_Queretaro", label: "ケレタロ" },
    { value: "ClubSantos", label: "サントス・ラグナ" },
    { value: "Xolos", label: "クラブ・ティフアナ" },
    { value: "tolucafc", label: "デポルティーボ・トルーカ" },
    { value: "tigresoficial", label: "ティグレス" },
    { value: "PumasMX", label: "クラブ・ウニベルシダ・ナシオナル" },
  ],
  MSLE : [
    { value: "cfmontreal", label: "モントリオール" },
    { value: "OrlandoCitySC", label: "オーランド・シティ" },
    { value: "PhilaUnion", label: "フィラデルフィア・ユニオン" },
    { value: "Cincinnati", label: "シンシナティ" },
    { value: "NewYorkRedBulls", label: "ニューヨーク・レッドブルズ" },
    { value: "NYCFC", label: "ニューヨーク・シティ" },
    { value: "ATLUTD", label: "アトランタ・ユナイテッド" },
    { value: "dcunited", label: "D.C. ユナイテッド" },
    { value: "CharlotteFC", label: "シャーロット" },
    { value: "ColumbusCrew", label: "コロンバス・クルー" },
    { value: "NERevolution", label: "ニューイングランド・レボリューション" },
    { value: "TorontoFC", label: "トロント" },
    { value: "InterMiamiCF", label: "インテル・マイアミ" },
    { value: "ChicagoFire", label: "シカゴ・ファイアー" },
  ],
  MSLW : [
    { value: "LAFC", label: "ロサンゼルスFC" },
    { value: "AustinFC", label: "オースティン" },
    { value: "LAGalaxy", label: "ロサンゼルス・ギャラクシー" },
    { value: "FCDallas", label: "ダラス" },
    { value: "realsaltlake", label: "レアル・ソルトレイク" },
    { value: "NashvilleSC", label: "ナッシュビル" },
    { value: "MNUFC", label: "ミネソタ・ユナイテッド" },
    { value: "HoustonDynamo", label: "ヒューストン・ダイナモ" },
    { value: "ColoradoRapids", label: "コロラド・ラピッズ" },
    { value: "TimbersFC", label: "ポートランド・ティンバーズ" },
    { value: "SJEarthquakes", label: "サンノゼ・アースクエイクス" },
    { value: "SportingKC", label: "スポルティング・カンザスシティ" },
    { value: "SoundersFC", label: "シアトル・サウンダーズ" },
    { value: "WhitecapsFC", label: "バンクーバー・ホワイトキャップス" },
  ],
  NWSL : [
    { value: "ThornsFC", label: "ポートランド・ソーンズFC" },
    { value: "OLReign", label: "OLレイン" },
    { value: "WashSpirit", label: "ワシントン・スピリット" },
    { value: "chicagoredstars", label: "シカゴ・レッドスターズ" },
    { value: "GothamFC", label: "NJ/NY ゴッサムFC" },
    { value: "TheNCCourage", label: "ノース・カロライナ・カレッジ" },
    { value: "HoustonDash", label: "ヒューストン・ダッシュ" },
    { value: "ORLPride", label: "オーランド・プライド" },
    { value: "RacingLouFC", label: "レーシング・ルイビルFC" },
    { value: "thekccurrent", label: "カンザスシティ" },
    { value: "weareangelcity", label: "エンジェル・シティーFC" },
  ],
  J1 : [
    { value: "frontale_staff", label: "川崎フロンターレ" },
    { value: "prompt_fmarinos", label: "横浜F・マリノス" },
    { value: "visselkobe", label: "ヴィッセル神戸" },
    { value: "atlrs_official", label: "鹿島アントラーズ" },
    { value: "nge_official", label: "名古屋グランパス" },
    { value: "REDSOFFICIAL", label: "浦和レッズ" },
    { value: "saganofficial17", label: "サガン鳥栖" },
    { value: "AvispaF", label: "アビスパ福岡" },
    { value: "fctokyoofficial", label: "FC東京" },
    { value: "consaofficial", label: "コンサドーレ札幌" },
    { value: "sanfrecce_SFC", label: "サンフレッチェ広島" },
    { value: "crz_official", label: "セレッソ大阪" },
    { value: "GAMBA_OFFICIAL", label: "ガンバ大阪" },
    { value: "spulse_official", label: "清水エスパルス" },
    { value: "REYSOL_Official", label: "柏レイソル" },
    { value: "bellmare_staff", label: "湘南ベルマーレ" },
    { value: "Jubiloiwata_YFC", label: "ジュビロ磐田" },
    { value: "sangafc", label: "京都サンガ" },
  ],
  J2 : [
    { value: "vortis_pr", label: "徳島ヴォルティス" },
    { value: "TRINITAofficial", label: "大分トリニータ" },
    { value: "vega_official_", label: "ベガルタ仙台" },
    { value: "yokohama_fc", label: "横浜FC" },
    { value: "vfk_official", label: "ヴァンフォーレ甲府" },
    { value: "v_varenstaff", label: "V・ファーレン長崎" },
    { value: "FcMachidaZelvia", label: "町田ゼルビア" },
    { value: "albirex_pr", label: "アルビレックス新潟" },
    { value: "monte_prstaff", label: "モンテディオ山形" },
    { value: "jef_united", label: "ジェフ千葉" },
    { value: "fcr_info", label: "FC琉球" },
    { value: "hollyhock_staff", label: "水戸ホーリーホック" },
    { value: "fagiano_koho", label: "ファジアーノ岡山" },
    { value: "TokyoVerdySTAFF", label: "東京ヴェルディ" },
    { value: "blaublitz_akita", label: "ブラウブリッツ秋田" },
    { value: "tochigisc", label: "栃木SC" },
    { value: "renofayamaguchi", label: "レノファ山口" },
    { value: "Ardija_Official", label: "大宮アルディージャ" },
    { value: "zweigen_staff", label: "ツエーゲン金沢" },
    { value: "OfficialThespa", label: "ザスパクサツ群馬" },
    { value: "roassoofficial", label: "ロアッソ熊本" },
    { value: "IwateGrulla", label: "いわてグルージャ盛岡" },
  ],
  J3 : [
    { value: "sc_sagamihara", label: "SC相模原" },
    { value: "ehime_fc", label: "愛媛FC" },
    { value: "Giravanz_staff", label: "ギラヴァンツ北九州" },
    { value: "yamagafc", label: "松本山雅" },
    { value: "katallertoyama", label: "カターレ富山" },
    { value: "55tegevajaro", label: "テゲバジャーロ宮崎" },
    { value: "fufc_staff", label: "福島ユナイテッドFC" },
    { value: "fcgifuDREAM", label: "FC岐阜" },
    { value: "kagoshimaufc", label: "鹿児島ユナイテッド" },
    { value: "yscc1986", label: "Y.S.C.C.横浜" },
    { value: "NAGANO_PARCEIRO", label: "AC長野パルセイロ" },
    { value: "fujiedamyfc_pr", label: "藤枝MYFC" },
    { value: "FCimabari", label: "FC今治" },
    { value: "gainareofficial", label: "ガイナーレ鳥取" },
    { value: "vanraure", label: "ヴァンラーレ八戸" },
    { value: "azulclaro1990", label: "アスルクラロ沼津" },
    { value: "kamatama_kouhou", label: "カマタマーレ讃岐" },
    { value: "IwakiFcOfficial", label: "いわきFC" },
  ],
  WE : [
    { value: "mynavisendai", label: "マイナビ仙台レディース" },
    { value: "REDSLADIES", label: "三菱重工浦和レッズレディース" },
    { value: "Ardija_VENTUS", label: "大宮アルディージャVENTUS" },
    { value: "elfen_official", label: "ASエルフェン埼玉" },
    { value: "jefchiba_ladies", label: "ジェフ・レディース" },
    { value: "tokyo_beleza", label: "日テレ・ベレーザ" },
    { value: "nojimastella", label: "ノジマステラ神奈川相模原" },
    { value: "PARCEIRO_LADIES", label: "AC長野パルセイロ・レディース" },
    { value: "albirexL", label: "アルビレックス新潟レディース" },
    { value: "inac_kobe2001", label: "INAC神戸レオネッサ" },
    { value: "sanfrecceREGINA", label: "サンフレッチェ広島レジーナ" },
  ],
  Nadeshiko1 : [
    { value: "iga_kunoichi", label: "伊賀FCくノ一三重" },
    { value: "sfidafc", label: "スフィーダ世田谷" },
    { value: "cerezo_ladies", label: "セレッソ大阪堺レディース" },
    { value: "ehime_fcl", label: "愛媛FCレディース" },
    { value: "yfcseagulls", label: "横浜FCシーガルズ" },
    { value: "HARIMA_ALBION", label: "ASハリマアルビオン" },
    { value: "LoveledgeNagoya", label: "ラブリッジ名古屋" },
    { value: "orcakamogawafc", label: "オルカ鴨川" },
    { value: "speranzafc", label: "スペランツァ大阪高槻" },
    { value: "ange_violet_", label: "アンジュヴィオレ広島" },
    { value: "whitestar_gunma", label: "バニーズ群馬fcホワイトスター" },
  ],
  Nadeshiko2 : [
    { value: "sylphid1998", label: "大和シルフィード" },
    { value: "ssubonita", label: "静岡SSUボニータ" },
    { value: "norddea", label: "ノルディーア北海道" },
    { value: "tsukubafc", label: "つくばＦＣレディース" },
    { value: "all_for_smile", label: "吉備国際大学Charme岡山高梁" },
    { value: "yunogo__belle", label: "岡山湯郷Belle" },
    { value: "Diavoross0", label: "ディアヴォロッソ広島" },
    { value: "Veertien_Ladies", label: "ヴィアティン三重レディース" },
  ],
};

const TwitterTimeLine2 = () => {
  const [league, setLeague] = useState("LaLiga");
  const [continent, setContinent] = useState("Europe_m");
  const [url, setUrl] = useState("realmadrid");
  const [options, setOptions] = useState(LeagueOptions.LaLiga);
  const [continents, setContinents] = useState(LeagueContinents.Europe_m);
  // const [url2, setUrl2] = useState("https://twitter.com/LaLiga");
  // const [twID, setTwID] = useState("692527862369357824");
  // const classes = useStyles();
  // const [state, setState] = useContext(SoccerWordContext);
  
  useEffect(() => {
    // var container = document.querySelector('#document');
    // var spanText = document.getElementById('twitter-widget-0');
  // var spanText = document.getElementsByClassName('MuiPaper-root');
// console.log(spanText);              // <span>
// console.log(spanText.textContent);  // "Text"
  // debugger;
// var shadowroot = element.shadowRoot;
  // const el=document.getElementsByClassName("env-bp-330");
    // if( el.shadowRoot != null ){
    //     var sroot = el.shadowRoot;
    //     const style = document.createElement('style');
    //     style.textContent = '.SandboxRoot { font-size:28px; }';
    //     sroot.appendChild(style);
    // }else{
    //     changeTwitterArticleDesign();
    // }
  }, []);

  // const handleChange = (event, val) => {
  //   if (val != null) {
  //     setLeague(val);
  //     setOptions(LeagueOptions[val]);
  //     setUrl(LeagueOptions[val][0].value);
  //   }
  //   // if (LeagueOptions[val][0].value !== null) {
  //   //   // debugger;
  //   //   setState((state) => ({ ...state, url: LeagueOptions[val][0].value }));
  //   //   // console.log(state.url);
  //   // }    
  // };

  const handleChangeSelect = (selectedOption) => {
    setUrl(selectedOption.value);
    // setUrl2("https://twitter.com/" + selectedOption.value);

    // if (selectedOption.value !== null) {
    //   // debugger;
    //   setState((state) => ({ ...state, url: selectedOption.value }));
    //   // console.log(state.url);
    // }
  };

  const handleChange2 = (event, val) => {
    if (val != null) {
      setContinent(val);
      setContinents(LeagueContinents[val]);
      setLeague(LeagueContinents[val][0].value);
      setOptions(LeagueOptions[LeagueContinents[val][0].value]);
      setUrl(LeagueOptions[LeagueContinents[val][0].value][0].value);
    }
  };
  const handleChangeSelect2 = (selectedOption) => {
    if (selectedOption.value != null) {
      setLeague(selectedOption.value);
      setOptions(LeagueOptions[selectedOption.value]);
      setUrl(LeagueOptions[selectedOption.value][0].value);
    }
  };

  return (
    <div>
      <ToggleButtonGroup
        value={continent}
        exclusive
        size="small"
        onChange={handleChange2}
        aria-label="continents"
      >
        <ToggleButton value="Europe_m" aria-label="Europe_m">
          欧州
        </ToggleButton>
        <ToggleButton value="SAmerica_m" aria-label="SAmerica_m">
          南米
        </ToggleButton>
        <ToggleButton value="NAmerica_m" aria-label="NAmerica_m">
          北中米
        </ToggleButton>
        <ToggleButton value="Asia_m" aria-label="Asia_m">
          アジア
        </ToggleButton>
      </ToggleButtonGroup>

      <Select
        // defaultValue={options[0]}
        value={continents.filter((option) => option.value === league)}
        // isMulti
        name="colors"
        options={continents}
        className="basic-multi-select"
        classNamePrefix="select"
        onChange={handleChangeSelect2}
        isSearchable={false}
        // clearValue={}
      />
      {/* <ToggleButtonGroup
        value={league}
        exclusive
        size="small"
        onChange={handleChange}
        aria-label="league"
      >
        <ToggleButton value="LaLiga" aria-label="LaLiga">
          ラ・リーガ
        </ToggleButton>
        <ToggleButton value="SerieA" aria-label="SerieA">
          セリエＡ
        </ToggleButton>
        <ToggleButton value="bundesliga_de" aria-label="bundesliga_de">
          ブンデス
        </ToggleButton>
        <ToggleButton value="premierleague" aria-label="premierleague">
          プレミア
        </ToggleButton>
        <ToggleButton value="League1" aria-label="League1">
          リーグ・アン
        </ToggleButton>
        <ToggleButton value="JupilerLeague" aria-label="JupilerLeague">
          ジュピラー
        </ToggleButton>
        <ToggleButton value="japaneseplayer" aria-label="japaneseplayer">
          日本人所属
        </ToggleButton>
      </ToggleButtonGroup> */}
      <Select
        // defaultValue={options[0]}
        value={options.filter((option) => option.value === url)}
        // isMulti
        name="colors"
        options={options}
        className="basic-multi-select"
        classNamePrefix="select"
        onChange={handleChangeSelect}
        isSearchable={false}
        // clearValue={}
      />
      <Timeline
        dataSource={{
          sourceType: "profile",
          screenName: url,
        }}
        options={{
          // size: "large",
          lang: "ja",
          chrome: "noheader, nofooter",
          width: "500",
          height: "400",
        }}
      />
      {/* <TwitterTimelineEmbed
  sourceType="profile"
  screenName="saurabhnemade"
  options={{height: 400}}
/> */}
      {/* <a
        class="twitter-timeline"
         
        href={url2}
        // href={"https://twitter.com/" + url}
        data-chrome="nofooter noborders"
        data-height="400"
      >
      </a> */}
      {/* <a className="twitter-timeline"
        // data-width="300"
        data-height="400"
        data-chrome="noheadernofooternoborders"
        href={url2}
        // href="https://twitter.com/FCBarcelona_es?ref_src=twsrc%5Etfw"
      >
        </a>
      <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script> */}
      {/* ReactでTwitterのタイムラインなどを埋め込む */}
      {/* https://blog.narumium.net/2020/04/06/react%E3%81%A7twitter%E3%81%AE%E3%82%BF%E3%82%A4%E3%83%A0%E3%83%A9%E3%82%A4%E3%83%B3%E3%81%AA%E3%81%A9%E3%82%92%E5%9F%8B%E3%82%81%E8%BE%BC%E3%82%80/ */}

      {/* <TweetEmbed id={twID} /> */}
      {/* <Twemb /> */}
    </div>
  );
};

export default TwitterTimeLine2;
